module.exports = __webpack_public_path__ + "media/images/favicon/android-icon-36x36-1d01db1ddaf0982011cc9d70bf1c582b.png";